import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Sale = () => {
    document.title = "Satış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Satış", value: "/cash/sale", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Satış</h2>
                    <p>
                        <ol>
                            <li>
                                Pərakəndə satışları icra etmək üçün kassa proqramında axtarış hissəsində satılacaq məhsul axtarılır və satış üçün səbətə əlavə
                                olunur
                            </li>
                            <li>Satılacaq məhsulun miqdarı, satış qiyməti, endirim dəyişilə bilər</li>
                            <li>Cəm məbləğ üzərinə klik olunduqda açılan pəncərədə ödəniş növünü (nəğd, nəğgsiz, bonus, borc) seçmək lazımdır</li>
                            <li>
                                <mark>Ümumi məbləğ</mark> yazısının üzərinə klik olunduqda satış əməliyyatı tamamlanır
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/sale-1.gif" alt="Satış" />
                    <h2>Barkod skaner (oxuyucu) ilə satış</h2>
                    <p>
                        <ol>
                            <li>
                                Pərakəndə satışları icra etmək üçün kassa proqramında axtarış hissəsində satılacaq məhsulun üzərindəki barkod oxudularaq səbətə
                                əlavə olunur
                            </li>
                            <li>Satılacaq məhsulun miqdarı, satış qiyməti, endirim dəyişilə bilər</li>
                            <li>Cəm məbləğ üzərinə klik olunduqda açılan pəncərədə ödəniş növünü (nəğd, nəğgsiz, bonus, borc) seçmək lazımdır</li>
                            <li>
                                <mark>Ümumi məbləğ</mark> yazısının üzərinə klik olunduqda satış əməliyyatı tamamlanır
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/sale-2.gif" alt="Satış" />
                </article>
            </div>
        </div>
    );
};
